import { footerStats, footerColumns } from "@/mocks/homeData";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-800 text-background-100">
      <div className="px-4 md:px-8 pt-12 pb-8">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[320px] shrink-0">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 rounded-md bg-primary-600 text-background-50 font-heading font-black text-xl flex items-center justify-center">
                91
              </span>
              <span className="font-heading font-black text-2xl text-background-50">91网</span>
            </div>
            <p className="mt-4 text-sm text-background-100/80 leading-relaxed">
              聚合热门视频、资源合集与推荐内容，覆盖各类题材。无论你想看合集还是热门推荐，都能在这里快速找到。
            </p>
            <a
              href="#download"
              className="mt-6 inline-flex items-center gap-2 h-10 px-4 rounded-md bg-accent-500 text-accent-950 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-accent-400"
            >
              <i className="ri-download-2-line" /> 下载客户端
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 flex-1">
            {footerColumns.map((col) => (
              <div key={col.title}>
                <h3 className="font-heading text-sm font-bold text-background-50 mb-4">{col.title}</h3>
                <ul className="space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link}>
                      <button
                        type="button"
                        className="text-sm text-background-100/75 hover:text-accent-300 cursor-pointer whitespace-nowrap"
                      >
                        {link}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/15 grid grid-cols-2 md:grid-cols-4 gap-6">
          {footerStats.map((stat) => (
            <div key={stat.label}>
              <p className="font-heading text-2xl font-black text-background-50">{stat.value}</p>
              <p className="mt-1 text-xs text-background-100/70">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-100/70">
          <p>© 2026 91网 · 内容聚合与推荐 · 本站仅提供内容索引，不存储任何资源文件</p>
          <div className="flex items-center gap-5">
            <button type="button" className="hover:text-accent-300 cursor-pointer">用户协议</button>
            <button type="button" className="hover:text-accent-300 cursor-pointer">隐私政策</button>
            <a href="#top" className="inline-flex items-center gap-1 hover:text-accent-300 cursor-pointer">
              回到顶部 <i className="ri-arrow-up-line" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}